export function maskText(data: string): string {
  if (data && data.length > 4) {
    const digits = data.slice(-4);
    const mask = '*'.repeat(data.length - 4);

    return mask + digits;
  } else {
    return data;
  }
}
